import marked from 'marked';
import memoize from 'lodash/memoize';
import { DefaultRenderer } from './DefaultRenderer';
import { ArticleRenderer } from './ArticleRenderer';

export const defaultMarkdown = memoize(text =>
  marked(text, { renderer: new DefaultRenderer() }),
);

export const articleMarkdown = memoize((text, initialDropcap = false) => {
  const renderer = new ArticleRenderer();
  renderer.initialDropcap = initialDropcap;

  // temporary? Replace manually embedded iframes with the correct
  // widget codes
  const txt = text
    .replace(
      /<iframe.* src=".*youtube.com\/embed\/([^"]+)".*><\/iframe>/gi,
      '[youtube-video $1]',
    )
    .replace(
      /<iframe.* src=".*open.spotify.com\/embed\/([^"]+)".*><\/iframe>/gi,
      (_: any, p1: string) => `[play-button spotify:${p1.replace('/', ':')}]`,
    );

  return marked(txt, { renderer });
});
